import { SENSOR_CODE } from '@/router/views/report/lib/variables'
import { normalizeFuelValues } from './fuel-helper'

const percentages = [20, 40, 60, 80, 100]

function createRangeAxis(id, title, position, bands) {
  const values = bands.map((band) => band.value)
  const labels = new Map(bands.map((band) => [band.value, band.display]))
  return {
    id,
    type: 'linear',
    position,
    display: true,
    weight: 1,
    scaleLabel: { display: true, labelString: title },
    gridLines: { color: 'rgba(166, 176, 207, 0.1)', drawOnChartArea: false },
    ticks: {
      min: values[0],
      max: values[values.length - 1],
      // Bound Chart.js's automatic generator, which runs before afterBuildTicks.
      stepSize: (values[values.length - 1] - values[0]) / 4,
      autoSkip: false,
      maxTicksLimit: 5,
      callback: (value) => labels.get(Number(value)) ?? '',
    },
    afterBuildTicks: (scale) => {
      const ticks = [...values]
      if (!scale.isHorizontal()) ticks.reverse()
      if (scale.options.ticks.reverse) ticks.reverse()
      return ticks
    },
  }
}

export function buildFuelRangeAxes(records, columns, isScoped) {
  const isOdo =
    records.length > 0 &&
    records.every(
      (record) =>
        Array.isArray(record?.sensors) &&
        record.sensors.some((sensor) => sensor?.sensorCode == SENSOR_CODE.FUEL_ODO)
    ) &&
    isScoped
  const result = { axes: [], isOdo, percentageAxisId: null }
  if (!isOdo) return result

  const bands = percentages.map((percentage) =>
    normalizeFuelValues([{ sensorCode: SENSOR_CODE.FUEL_ODO }], null, percentage, null, isScoped)
  )
  if (columns.includes('fuelPercentage')) {
    result.percentageAxisId = 'fuel-range-percentage'
    result.axes.push(
      createRangeAxis(
        result.percentageAxisId,
        'Bahan Bakar (%)',
        'left',
        bands.map((band) => band.fuelPercentage)
      )
    )
  }
  return result
}
